import React from "react";
import moment from "moment";
import ClearIcon from "react-icons/lib/md/clear";
import { TextField, IconButton, InputAdornment, TextFieldProps } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import DatePicker from "@components/DatePicker";
import { Grid3 } from "./Grid3";
import { SearchSelect } from "@components/Select/SearchSelect";

export function renderFrom(
  value: Date,
  onChange: (v: Date) => void,
  dirty: boolean,
  before: Date,
  disabled?: boolean,
  label?: string
) {
  return (
    <Grid3 dirty={dirty}>
      <DatePicker
        label={label ? label : locale.SelectSomething(locale.StartDate)}
        filterDate={(date) => (before ? moment(date).isBefore(before, "date") : true)}
        value={value ? moment(value) : null}
        onChange={(v) => onChange(v ? v.utc(true).toDate() : null)}
        align="right"
        fullWidth
        showWeekNumbers
        disabled={disabled}
      />
    </Grid3>
  );
}

export function renderTo(
  value: Date,
  onChange: (v: Date) => void,
  dirty: boolean,
  after: Date,
  disabled?: boolean,
  label?: string
) {
  return (
    <Grid3 dirty={dirty}>
      <DatePicker
        label={label ? label : locale.SelectSomething(locale.EndDate)}
        filterDate={(date) => (after ? moment(date).isSameOrAfter(after, "date") : true)}
        value={value ? moment(value) : null}
        onChange={(v) => onChange(v ? v.utc(true).toDate() : null)}
        align="right"
        fullWidth
        showWeekNumbers
        disabled={disabled}
      />
    </Grid3>
  );
}

export function renderZipCityField(
  label: string,
  value: string,
  onChange: (v: string) => void,
  dirty: boolean,
  disabled?: boolean
) {
  return (
    <Grid3 dirty={dirty} style={{ maxWidth: "100%" }}>
      <TextField
        disabled={disabled}
        fullWidth
        placeholder={locale.Search}
        onChange={(e) => onChange(e.target.value)}
        label={label}
        value={value}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={(e) => onChange("")}>
                <ClearIcon fontSize="small" />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
    </Grid3>
  );
}

export function renderTextField(
  label: string,
  value: string,
  onChange: (v: string) => void,
  dirty: boolean,
  disabled?: boolean,
  textFieldProps?: TextFieldProps
) {
  return (
    <Grid3 dirty={dirty}>
      <TextField
        fullWidth
        label={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        {...textFieldProps}
      />
    </Grid3>
  );
}

export function renderSelect(
  label: string,
  options: LabelValue[],
  sortOptions: boolean,
  value: string,
  onChange: (v: string) => void,
  disabled: boolean,
  dirty: boolean
) {
  return (
    <Grid3 dirty={dirty}>
      <SearchSelect
        label={label}
        options={options}
        sortOptions={!sortOptions ? false : undefined}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </Grid3>
  );
}

export function renderMultiSelect(
  label: string,
  options: LabelValue[],
  sortOptions: boolean,
  value: string[],
  onChange: (v) => void,
  disabled: boolean,
  dirty: boolean
) {
  return (
    <Grid3 dirty={dirty}>
      <SearchSelect
        clearable
        label={label}
        options={options}
        sortOptions={false}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
    </Grid3>
  );
}
